import { Typography } from '@optimus-web/core';
import { AccountName } from '../../../../components/common/AccountName';
import { ProductCheckListDataRow } from '../../types';
import { ProductCheckListDataTestIds } from '../../constants';

interface OwnerCellProps {
    row: ProductCheckListDataRow;
    active?: boolean;
}

export const OwnerCell: React.FC<OwnerCellProps> = ({ row, active = true }) => {
    if (!row.owner || !row.reservation) {
        return null;
    }

    return (
        <Typography
            textStyle="bodyMediumStrong"
            variant={!active ? 'tertiary' : 'primary'}
            data-test-id={ProductCheckListDataTestIds.cellOwner}
            data-test-owner-id={row.owner.id}
            as="div"
        >
            <AccountName account={row.owner} reverse />
        </Typography>
    );
};
